import api from './api'; // ajuste para o client axios/fetch já usado no projeto

export async function getApexLoginUrl(cnpj, codPessoaSft) {
  const { data } = await api.get('/apex/login-url', {
    params: { cnpj, codPessoaSft }
  });
  return data; // esperado: { url: 'https://.../f?p=280:1:&x01=...' }
}